module.exports = __webpack_public_path__ + "static/media/TotalPersonas.7aef42ef.svg";